import { experimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/experimentalQuery';
import { MediaType } from '@confluence/graphql/entry-points/MediaType';

import type {
	ContentBodyConvertQuery as ContentBodyConvertQueryData,
	ContentBodyConvertQueryVariables,
} from './__types__/ContentBodyConvertQuery';

export const experimentalContentBodyConvertQuery = async (
	from: string,
	to: string,
	body: string,
	contentIdContext?: string,
): Promise<ContentBodyConvertQueryData> => {
	const variables: ContentBodyConvertQueryVariables = {
		from,
		to,
		body,
		contentIdContext,
	};

	const requestBody = {
		representation: from,
		value: body,
	};

	const params = new URLSearchParams();
	if (contentIdContext) {
		params.append('contentIdContext', contentIdContext);
	}

	const queryString = params.toString();
	const queryParams = queryString ? `?${queryString}` : '';
	const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;

	const result = await experimentalQuery<
		ContentBodyConvertQueryData,
		ContentBodyConvertQueryVariables,
		ContentBodyConvertResponse
	>({
		url,
		method: 'POST',
		body: JSON.stringify(requestBody),
		credentials: 'include',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResponseOnSuccess: async (response) => {
			if (response.ok && response.status === 200) {
				return response.json();
			}
			throw response;
		},
		parseResponseOnError: (error: any) => {
			throw new Error(
				`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`,
			);
		},
		parseResult: (response: ContentBodyConvertResponse) => ({
			experimentalContentBodyConvert: {
				value: response.value,
			},
		}),
		variables,
	});

	return result.data;
};

type ContentBodyConvertResponse = {
	value: string | null;
};
